module.exports = __webpack_public_path__ + "static/media/thumb-tv.99671143.svg";